import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { GraduationCap, Sprout, BarChart3, Landmark, CheckCircle2, Clock } from "lucide-react";
import api from "../lib/api";
import { Skeleton } from "../components/ui/skeleton";
import { Progress } from "../components/ui/progress";

const TRACK_ICONS = { foundations: Sprout, analysis: BarChart3, uk: Landmark };

export default function Learn() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/learn/tracks").then((r) => setData(r.data));
  }, []);

  return (
    <div className="space-y-8 fade-up">
      <div className="flex items-end justify-between flex-wrap gap-4">
        <div>
          <div className="overline-label mb-2">Investor education</div>
          <h1 className="font-heading font-black tracking-tighter text-4xl sm:text-5xl text-white flex items-center gap-3">
            Learning Centre <GraduationCap className="w-8 h-8 text-primary" />
          </h1>
        </div>
        {data && (
          <div className="widget p-4 min-w-[220px]" data-testid="learn-progress-card">
            <div className="overline-label mb-2">Your progress</div>
            <Progress value={(data.total_completed / data.total_lessons) * 100} className="h-2" />
            <div className="font-mono text-xs text-muted-foreground mt-2">
              {data.total_completed} / {data.total_lessons} lessons completed
            </div>
          </div>
        )}
      </div>

      {!data ? (
        <Skeleton className="h-72 rounded-sm bg-card" />
      ) : (
        data.tracks.map((t) => {
          const Icon = TRACK_ICONS[t.id] || GraduationCap;
          return (
            <div key={t.id} data-testid={`track-section-${t.id}`}>
              <div className="flex items-center gap-2 mb-1">
                <Icon className="w-4 h-4 text-primary" />
                <h2 className="font-heading font-bold text-lg text-white tracking-tight">{t.name}</h2>
                <span className="font-mono text-xs text-muted-foreground ml-2">{t.completed_count}/{t.lesson_count} done</span>
              </div>
              <p className="text-sm text-muted-foreground mb-4">{t.description}</p>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                {t.lessons.map((l) => (
                  <Link key={l.id} to={`/learn/${l.id}`} data-testid={`lesson-card-${l.id}`}
                    className={`widget p-4 group block transition-colors duration-150 ${
                      l.completed ? "border-gain/40" : "hover:border-primary/60"}`}>
                    <div className="flex items-start justify-between gap-2">
                      <div className="font-heading font-bold text-white tracking-tight text-sm leading-snug group-hover:text-primary transition-colors duration-150">
                        {l.title}
                      </div>
                      {l.completed && <CheckCircle2 className="w-4 h-4 text-gain shrink-0" />}
                    </div>
                    <p className="text-xs text-muted-foreground leading-relaxed mt-2">{l.summary}</p>
                    <div className="flex items-center justify-between mt-3 text-[11px] font-mono text-muted-foreground/70">
                      <span className="flex items-center gap-1"><Clock className="w-3 h-3" /> {l.minutes} min</span>
                      {l.completed && l.score != null && <span className="text-gain">quiz {l.score}/3</span>}
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          );
        })
      )}

      <p className="text-xs text-muted-foreground border-t border-border pt-4">
        This is educational content, not financial advice.
      </p>
    </div>
  );
}
